var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreNow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0013 18.9596C5.05963 18.9596 1.04297 14.943 1.04297 10.0013C1.04297 5.05963 5.05963 1.04297 10.0013 1.04297C14.943 1.04297 18.9596 5.05963 18.9596 10.0013C18.9596 14.943 14.943 18.9596 10.0013 18.9596ZM10.0013 2.29297C5.7513 2.29297 2.29297 5.7513 2.29297 10.0013C2.29297 14.2513 5.7513 17.7096 10.0013 17.7096C14.2513 17.7096 17.7096 14.2513 17.7096 10.0013C17.7096 5.7513 14.2513 2.29297 10.0013 2.29297Z",
    fill: "#37D660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.81719 12.9827C8.65052 12.9827 8.49219 12.916 8.37552 12.7993L6.01719 10.441C5.77552 10.1993 5.77552 9.79935 6.01719 9.55768C6.25885 9.31602 6.65885 9.31602 6.90052 9.55768L8.81719 11.4743L13.1005 7.19102C13.3422 6.94935 13.7422 6.94935 13.9839 7.19102C14.2255 7.43268 14.2255 7.83268 13.9839 8.07435L9.25885 12.7993C9.14219 12.916 8.98385 12.9827 8.81719 12.9827Z",
    fill: "#37D660"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreNow);
export default __webpack_public_path__ + "static/media/explore-now.51c61ef683f36487d63613d71a0bc97c.svg";
export { ForwardRef as ReactComponent };